import { HttpParams } from "@angular/common/http";

// eslint-disable-next-line @tseslint/typedef
export const PROJECT_PAYLOAD_CHUNKS = {
  /** Base data payload chunk */
  baseData: "BASE_DATA",
  /** Minimal information of the Project such as status, name and number */
  minimal: "DEFAULT"
} as const;
export type ProjectPayloadChunk = typeof PROJECT_PAYLOAD_CHUNKS[keyof typeof PROJECT_PAYLOAD_CHUNKS];
export function buildProjectPayloadChunkParam (chunk: ProjectPayloadChunk): HttpParams {
  return new HttpParams().set("expand", chunk);
}
